import EmpNotesPage from "../Employee/EmpNotesPage";
import api from "../../services/api";

function PMNotesPg() {
  return (
    <EmpNotesPage
      notesApi={{
        getNotes: api.getPMNotes,
        addNote: api.addPMNote,
        updateNote: api.updatePMNote,
        deleteNote: api.deletePMNote
      }}
    />
  );
}

export default PMNotesPg;
